import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/plugin-guide/page.tsx");
